import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import {
  selectExistingOrdersWithoutCancelled,
  selectTestKitsGLIsCurrentlyOffering
} from "store/reducers/order/OrderInformationSlice";
import {
  figureOutKitsToOfferMemberRightNow
} from "utils/v3/testKitUtils";
import { combineArrayOfWordsWithCommasAndAnAndForLastItem } from "utils/utils";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { SHOW_ALL_NEXT_MOVE_CARDS } from "./showAllNextMoveCards";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const RequestDnaScreeningsNextMoveCard = () => {
  const history = useHistory();
  const {
    hasCompletedEnoughOfGettingStartedSurvey,
    memberNeedsToTalkToNav,
    previousSurveyAnswers,
    userInformation
  } = useNextMoveMemberContext();
  const kitsAlreadyOrdered = useSelector(selectExistingOrdersWithoutCancelled);
  const kitsGLCurrentlyOffers = useSelector(
    selectTestKitsGLIsCurrentlyOffering
  );
  const kitsToOfferMemberRightNow = figureOutKitsToOfferMemberRightNow(
    kitsGLCurrentlyOffers,
    kitsAlreadyOrdered,
    previousSurveyAnswers,
    "",
    userInformation.glProgramId
  );
  const hasKitsToOfferMemberRightNow = kitsToOfferMemberRightNow.length > 0;

  const onActionClick = useCallback(() => {
    trackDashboardCtaClicked({
      workflow: "kit_order",
      ctaLocation: "next_move_card",
      ctaId: "order_recommended_kits"
    });
    history.push(PATHS.ORDER_KIT_SELECTION);
  }, [history]);

  if (
    !SHOW_ALL_NEXT_MOVE_CARDS &&
    (!hasCompletedEnoughOfGettingStartedSurvey ||
      memberNeedsToTalkToNav ||
      !hasKitsToOfferMemberRightNow)
  ) {
    return null;
  }

  const testNamesArray = kitsToOfferMemberRightNow.map((kit) => kit.test_name);
  if (SHOW_ALL_NEXT_MOVE_CARDS && testNamesArray.length === 0) {
    testNamesArray.push("Genetic Health Screen");
  }
  const testNamesString = combineArrayOfWordsWithCommasAndAnAndForLastItem(
    testNamesArray
  );
  const hasMultipleTests = testNamesArray.length > 1;

  return (
    <NextMoveCard
      id="request-tests-next-move"
      title={<Translate text="Request your DNA screening" />}
      body={
        <Translate
          text={
            hasMultipleTests
              ? `Based on what you've shared, the following DNA screening tests are suggested for you: ${testNamesString}.`
              : `Based on what you've shared, the following DNA screening test is suggested for you: ${testNamesString}.`
          }
        />
      }
      subBody={
        <Translate
          text={
            hasMultipleTests
              ? "The next step is to confirm which tests you would like to receive."
              : "The next step is to confirm you would like to receive this test."
          }
        />
      }
      link={{
        onClick: onActionClick,
        overrideClick: true,
        url: PATHS.ORDER_KIT_SELECTION
      }}
    />
  );
};

export default RequestDnaScreeningsNextMoveCard;
